"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      textAlign: "center",
      margin: 0
    },
    dropzone: {
      marginBottom: theme.spacing(1)
    },
    errorMessage: {
      marginLeft: theme.spacing(1)
    },
    uploadedChip: {
      margin: theme.spacing(0.5)
    },
    uploadedChipFilename: {
      marginRight: theme.spacing(0.5)
    },
    uploadedChipFileSize: {
      color: theme.palette.text.secondary
    },
    loader: {
      height: "16px !important",
      width: "16px !important",
      padding: 8
    },
    dropzoneInner: {
      cursor: "pointer",
      padding: theme.spacing(2),
      border: "dashed",
      borderColor: theme.palette.grey["700"],
      borderRadius: "4px",
      transition: theme.transitions.create(["border", "background", "color"]),
      userSelect: "none"
    },
    dragAccept: {
      border: "solid " + theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText
    },
    dragReject: {
      border: "solid " + theme.palette.error.main,
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.contrastText
    },
    dropzoneDisabled: {
      cursor: "not-allowed",
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled
    },
    fullWidth: {
      width: "100%"
    }
  };
};

exports.styles = styles;